<template>
  <div v-if="port != null">
    <div class="dashboard-main-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <form id="portForm">
              <div class="form-box">
              <div class="form-content pb-2">
                <h3 class="title mb-3">Liman</h3>
                <div class="row justify-content-between">
                  <div class="col-lg-6">
                    <div class="card-item p-3">
                      <div class="contact-form-action">
                        <base-edit-input
                            v-model="port.name"
                            :rules="'required'"
                            :type="'text'"
                            :label="'Adı'">
                        </base-edit-input>
                        <base-edit-input
                            v-model="port.code"
                            :rules="'required'"
                            :type="'text'"
                            :label="'Kodu'">
                        </base-edit-input>
                        <base-text-area-input
                            v-model="port.description"
                            :rules="'required'"
                            :label="'Açıklama'">
                        </base-text-area-input>
                      </div>
                      <div class="btn-box">
                        <button v-if="port.id == null" :class="{'disabled' : !formValid}" @click="create" class="theme-btn" type="button">Kaydet</button>
                        <button v-if="port.id != null" :class="{'disabled' : !formValid}" @click="update" class="theme-btn" type="button">Güncelle</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="card-item p-3">
                      <div class="contact-form-action">
                        <div class="input-box">
                          <label class="label-text">Kapak Resmi</label>
                          <base-image-edit-input
                              v-model="port.imageUrl"
                              :rules="'required'">
                          </base-image-edit-input>
                        </div>
                        <div class="input-box row ml-2 m-2">
                          <label class="label-text">Web Sitesinde görüntüle</label>
                          <input class="form-control mt-2" style="width: 5rem;" type="checkbox" v-model="port.webVisibility">
                        </div>
                        <div class="input-box">
                          <base-edit-input
                              v-model="port.order"
                              :rules="'required|min_value:1'"
                              :type="'number'"
                              :label="'Sıra'">
                          </base-edit-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <div class="card-item p-3">
                    <v-app>
                      <v-data-table
                          :headers="headers"
                          :items="portImageList"
                          :items-per-page="5"
                          class="elevation-1">
                        <template v-slot:top>
                          <v-toolbar
                              flat>
                            <v-toolbar-title>Resimler</v-toolbar-title>
                            <v-divider
                                class="mx-4"
                                inset
                                vertical
                            ></v-divider>
                            <v-spacer></v-spacer>
                            <v-dialog
                                v-model="dialog"
                                max-width="500px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    dark
                                    class="mb-2"
                                    v-bind="attrs"
                                    v-on="on">
                                  New Item
                                </v-btn>
                              </template>
                              <v-card>
                                <v-card-title>
                                  <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                  <v-container>
                                    <v-row>
                                      <v-col
                                          cols="12"
                                          sm="6"
                                          md="4">
                                        <base-image-edit-input
                                            v-model="editedItem.imageUrl"
                                            :rules="'required'">
                                        </base-image-edit-input>
                                        <!--                                            <v-text-field-->
                                        <!--                                                v-model="editedItem.name"-->
                                        <!--                                                label="Market Adı"-->
                                        <!--                                            ></v-text-field>-->
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>

                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="close">
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="save">
                                    Save
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-toolbar>
                        </template>
                        <template v-slot:item.name="{ item }">
                          <tr>
                            <big-image-component v-if="item.imageUrl != null" :url="item.imageUrl"></big-image-component>
                          </tr>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <!--                              <v-icon-->
                          <!--                                  small-->
                          <!--                                  class="mr-2"-->
                          <!--                                  @click="editItem(item)"-->
                          <!--                              >-->
                          <!--                                mdi-pencil-->
                          <!--                              </v-icon>-->
                          <v-icon
                              small
                              @click="deleteItem(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                    </v-app>
                  </div>
              </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from "../common/UploadImage";
import validationFormUtils from "../../util/validationFormUtils";
import BaseImageEditInput from "../base/BaseImageEditInput";
import BaseTextAreaInput from "../base/BaseTextAreaInput";
import BaseEditInput from "../base/BaseEditInput";
import BigImageComponent from "../common/BigImageComponent";
import messagePopupManager from "../../util/messagePopupManager";
export default {
  name: "PortDetail",
  components: {BaseEditInput, BaseTextAreaInput, BaseImageEditInput, UploadImage,BigImageComponent},
  data () {
    return {
      dialog: false,
      dialogDelete: false,
      editedItem: {
        name: '',
      },
      defaultItem: {
        name: '',
      },
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'actions',
          value: 'actions',
        }
      ],
      formValid:false
    }
  },
  computed:{
    port:{
      get(){
        return this.$store.getters.getPort;
      }
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    portImageList:{
      get(){
        if(this.$store.getters.getPortImageList === null|| this.$store.getters.getPortImageList === undefined){
          return [];
        }
        return this.$store.getters.getPortImageList;
      }
    },
    portId:{
      get() {
        return this.$route.params.id;
      }
    }
  },
  methods:{
    create(){
      if(this.formValid) {
        this.$store.dispatch("createPort", this.port)
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
        })
      }
    },
    update(){
      if(this.formValid) {
        this.$store.dispatch("updatePort", this.port)
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
        })
      }
    },
    // editItem (item) {
    //   this.editedIndex = this.marketList.indexOf(item)
    //   this.editedItem = Object.assign({}, item)
    //   this.dialog = true
    // },

    deleteItem (item) {
      this.editedItem = Object.assign({}, item)
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deletePortImage",this.editedItem.id)
        .catch(error => {
          messagePopupManager.showError();
        })
      })
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      if (this.editedIndex > -1) {
        // this.$store.dispatch("updateMarket", {
        //   request : this.editedItem,
        //   callback:(updateMarket)=>{
        //   },
        //   fallback:()=>{
        //     messagePopupManager.showError();
        //   }
        // });
      } else {
        this.editedItem.portId = this.portId;

        this.$store.dispatch("createPortImage", this.editedItem)
        .catch(error => {
          messagePopupManager.showError();
        })
      }
      this.close()
    }
  },
  watch : {
    port : {
      deep : true,
      handler : function () {
        validationFormUtils.checkFormFields(this);
      }
    }
  },
  mounted() {
    if(this.portId !== 'new'){
      this.$store.dispatch("loadPortImages", this.portId);
    }else{
      this.$store.commit("setPortImageList", []);
    }
  }
}
</script>

<style scoped>

</style>